import React from 'react'

import { Nullable } from '@application/Types/Opt'

import { Arrow, Button, Footer, Text } from './ImageDescriptionSlideoutFooter.styled'

type SlideOutFooterProp = {
    onPrevClick: () => void
    onNextClick: () => void
    prevDisabled: boolean
    nextDisabled: boolean
    previousLabel: Nullable<string>
    nextLabel: Nullable<string>
}

export const ImageDescriptionSlideoutFooter = ({
    onPrevClick,
    onNextClick,
    prevDisabled,
    nextDisabled,
    previousLabel,
    nextLabel,
}: SlideOutFooterProp): JSX.Element => {
    return (
        <Footer>
            <Button onClick={onPrevClick} disabled={prevDisabled}>
                <Arrow direction="left" />
                <Text>{previousLabel}</Text>
            </Button>
            <Button onClick={onNextClick} disabled={nextDisabled}>
                <Text>{nextLabel}</Text>
                <Arrow />
            </Button>
        </Footer>
    )
}
